// @ts-nocheck
import { Descendant } from "slate";
import { CustomElement } from "./types";

export const dummyContent: CustomElement[] = [
  {
    type: "h1",
    children: [
      {
        text: "Hinweise zur Nutzung der Bedienungsanleitung",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Allgemein",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die hier beschriebene ",
      },
      {
        type: "project-data",
        key: "projectdata.product_name",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " wird zur Vereinfachung der Lesbarkeit im folgenden Text auch kurz als „Anlage/Maschine/Erzeugnis“ ",
      },
      {
        text: ">Hinweis: nicht zutreffendes bitte löschen<",
        highlight: true,
      },
      {
        text: " bezeichnet.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Bedienungsanleitung ist für den Personenkreis erstellt, der mit der Aufstellung, der Inbetriebnahme und dem Betrieb der Anlage beauftragt ist. Die Dokumentation muss daher für diesen Personenkreis stets zugänglich aufbewahrt werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Alle Sicherheits- und Warnhinweise auf und an der Anlage müssen jederzeit leserlich sein und bei Bedarf erneuert werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Zielgruppen",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Diese Bedienungsanleitung wendet sich an:",
      },
      {
        text: ">Hinweis: nicht zutreffendes bitte löschen bzw. weitere hinzufügen<",
        highlight: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Entscheidungsträger/Sicherheitsbeauftragte des Betreibers",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Betriebspersonal",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Wartungs- und Servicepersonal (Techniker)",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Hinweise auf Urheber- und Schutzrechte",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Diese Bedienungsanleitung ist vertraulich zu behandeln. Sie soll nur befugten Personen zugänglich gemacht werden. Sie darf Dritten nur mit schriftlicher Zustimmung der Firma ",
      },
      {
        type: "project-data",
        key: "manufacturer.company",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " überlassen werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Alle Unterlagen sind im Sinne des Urheberrechtes geschützt. Die Weitergabe und Vervielfältigung von Unterlagen, auch auszugsweise, sowie eine Verwertung und Mitteilung ihres Inhaltes sind nicht gestattet, sofern dies nicht ausdrücklich schriftlich zugestanden wird. Zuwiderhandlungen sind strafbar und verpflichten zu Schadensersatz. Die Ausübung aller gewerblichen Schutzrechte ist der Firma ",
      },
      {
        type: "project-data",
        key: "manufacturer.company",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " vorbehalten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Sicherheit ist wichtig",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Das Kapitel „Sicherheit“ muss dem Betriebs-, Wartungs- und Servicepersonal vor Handlungen an der Anlage zugänglich gemacht werden oder Bestandteil einer Unterweisung sein.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Anleitungen für Instandsetzung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Informationen zu Instandsetzungsarbeiten der Anlage werden mit entsprechenden Ersatzteillieferungen überreicht, sofern diese Informationen nicht zur gewöhnlichen Qualifikation von Instandhaltungsfachkräften gehören. Bei Fragen zur Instandsetzung steht Ihnen unser Service zur Verfügung.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Ergänzende Dokumentationen zu dieser Bedienungsanleitung",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Bedienungsanleitung und mitgeltende Informationen zu folgenden Maschinen/Komponenten:",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die ergänzenden Dokumente sind Teil dieser Bedienungsanleitung und müssen beim Betrieb aber insbesondere auch bei der Instandhaltung und Wartung beachtet werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Verwendete Sicherheits- und Warnhinweise",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "WARNUNG!",
            bold: true,
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Sicherheitshinweis zum Vermeiden ",
          },
          {
            text: "schwerer Gefahren für Personen",
            bold: true,
          },
          {
            text: ". Das Nichtbeachten kann ",
          },
          {
            text: "schwere (irreversible) Verletzungen",
            bold: true,
          },
          {
            text: " bis hin zum ",
          },
          {
            text: "Tod",
            bold: true,
          },
          {
            text: " zur Folge haben.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        bold: true,
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "warning",
    children: [
      {
        type: "title",
        children: [
          {
            text: "VORSICHT!",
            bold: true,
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Sicherheitshinweis zum Vermeiden von ",
          },
          {
            text: "Gefahren für Personen.",
            bold: true,
          },
          {
            text: " Das Nichtbeachten kann ",
          },
          {
            text: "leichte bis mittlere (reversible) Verletzungen ",
            bold: true,
          },
          {
            text: "zur Folge haben.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "attention",
    children: [
      {
        type: "title",
        children: [
          {
            text: "ACHTUNG!",
            bold: true,
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Kennzeichnung von unzulässigen Betriebs- oder Verhaltensweisen. Das Nichtbeachten kann ",
          },
          {
            text: "Sach- oder Umweltschäden",
            bold: true,
          },
          {
            text: " zur Folge haben.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "info",
    children: [
      {
        type: "title",
        children: [
          {
            text: "INFORMATION/EMPFEHLUNG!",
            bold: true,
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Nebenstehendes Symbol zeigt an, dass an dieser Stelle wichtige Informationen und Empfehlungen zum Umgang mit der Anlage gegeben werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Sicherheit",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Pflichten und Verantwortung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Der Betreiber ist verpflichtet, die Bedienungsanleitung zu befolgen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Es gelten die allgemeinen Arbeitsschutz- und Unfallverhütungsvorschriften. Beachten Sie unbedingt die in dieser Dokumentation enthaltenen Sicherheits- und Warnhinweise.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Einhaltung der Bedienungsanleitung ist Voraussetzung für den störungsfreien Betrieb und die Erfüllung eventueller Gewährleistungsansprüche. Lesen Sie aus diesem Grund zuerst diese Dokumentation, insbesondere die Sicherheitshinweise, bevor Sie mit der Anlage arbeiten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Bedienungsanleitung ist vom Betreiber um Betriebsanweisungen aufgrund nationaler Vorschriften zur Unfallverhütung und zum Umweltschutz zu ergänzen, einschließlich der Informationen zu Aufsichts- und Meldepflichten, zur Berücksichtigung betrieblicher Besonderheiten, zum Beispiel bezüglich Arbeitsorganisation, Arbeitsabläufe und eingesetztem Personal.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Neben der Bedienungsanleitung und den im Verwenderland sowie an der Einsatzstelle geltenden verbindlichen Regelungen zur Unfallverhütung sind auch die anerkannten fachtechnischen Regeln für sicherheits- und fachgerechtes Arbeiten zu beachten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Setzen Sie nur geschultes oder unterwiesenes Personal für die Bedienung, Wartung, Instandsetzung und den Transport der Maschine ein. ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Verwenden Sie bei Wartung und Reparatur ausschließlich durch den Hersteller freigegebene Ersatzteile.",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Der Betreiber darf ohne Genehmigung der Firma ",
      },
      {
        type: "project-data",
        key: "manufacturer.company",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " keine Veränderungen oder An- und Umbauten an der Anlage vornehmen, die die Sicherheit beeinträchtigen können. Dies gilt insbesondere für den Einbau und die Einstellung von Sicherheitseinrichtungen sowie für Schweißarbeiten an tragenden Bauteilen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: " ",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Bestimmungsgemäße Verwendung ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "boundary.expected_usage",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Weiter gilt:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Der/die/das>Hinweis: nicht zutreffendes bitte streichen<",
            highlight: true,
          },
          {
            text: " ",
          },
          {
            type: "project-data",
            key: "projectdata.product_name",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            text: " darf zu keinen anderen Zwecken verwendet werden als zu dem dafür entwickelten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Arbeiten an und mit der Anlage dürfen nur von autorisierten und unterwiesenen Personen durchgeführt werden. ",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Während des Betriebs der Anlage sind die allgemeinen Sicherheitsvorschriften zu befolgen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Bei Betrieb der Anlage ist grundsätzlich enganliegende Arbeitskleidung zu tragen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "info",
    children: [
      {
        type: "title",
        children: [
          {
            text: "INFORMATION/EMPFEHLUNG!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Zur bestimmungsgemäßen Verwendung gehört auch das Beachten aller Hinweise und Vorschriften der Bedienungsanleitung und aller Begleitdokumente",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Vorhersehbare Fehlanwendung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Zu den vorhersehbaren Fehlanwendungen gehören:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "",
          },
          {
            type: "project-data",
            key: "boundary.expected_misuse",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            text: "",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Der Einsatz von unzureichend qualifiziertem oder nicht unterwiesenem Personal.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: " ",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Nicht zulässige Handlung",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Die Bedienung oder der Betrieb der Maschine durch Personen, die nicht die Bedienungsanleitung gelesen oder eine Unterweisung speziell zu der Maschine erhalten haben, ist verboten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Während des Betriebs dürfen Schutzeinrichtungen wie Abdeckungen oder Gehäuseteile nicht demontiert werden.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Das Außerkraftsetzen, Überbrücken oder Manipulieren aller Sicherheits- und Schutzeinrichtungen ist verboten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Der Bediener darf die Grenzwerte der Maschine nicht überschreiten. Beachten Sie dazu die Angaben auf dem Typenschild bezüglich der Betriebsgrenzwerte.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Den Mitarbeitern ist es verboten, sich den Stellen zu nähern, an denen ihre Körperteile oder Kleidung erfasst werden könnten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Eigenmächtige Änderungen an der Maschine sind verboten.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Qualifikation und Berechtigung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Setzen Sie für Arbeiten an der Maschine nur Personen im Alter von mindestens 18 Jahren ein. Personen unter 18 Jahren dürfen an der Maschine nur unter ständiger Aufsicht eines für diese Arbeiten qualifizierten Volljährigen arbeiten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Arbeiten Sie nur an der Maschine, wenn Sie (aufgrund von Ausbildung, Berufserfahrung etc.) über die nötige Fachkenntnis verfügen. Arbeiten Sie an der Maschine zum Erlangen dieser Fachkenntnis, darf dies nur unter ständiger Aufsicht einer qualifizierten Person geschehen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Führen Sie nur Arbeiten durch, wenn Sie eine entsprechende Unterweisung erhalten haben.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "\t",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "WARNUNG!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Arbeiten an der elektrischen Installation dürfen grundsätzlich nur von Elektrofachkräften vorgenommen werden!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Arbeiten an pneumatischen oder hydraulischen Einrichtungen dürfen grundsätzlich nur von Fachkräften mit der entsprechenden Fachkenntnis vorgenommen werden!",
          },
        ],
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Bedienpersonal",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Hinweis: Nicht zutreffendes bitte streichen<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Erläuterung: ",
        bold: true,
      },
      {
        text: "Das Bedienpersonal umfasst diejenigen, die die Maschine im normalen Betriebszustand bedienen. Sie haben in der Regel eine Grundausbildung zur sicheren Bedienung der Maschine und sind mit den grundlegenden Funktionsweisen und Sicherheitsvorkehrungen vertraut.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Zum Tätigkeitsumfang des eingewiesenen Bedienpersonals gehören die folgende Handlungsschritte und Eingriffe:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Anlage für den Betrieb aktivieren und deaktivieren",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Bearbeitungsprozess starten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Anlage beschicken/Magazine auffüllen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Funktion der Sicherheitseinrichtungen kontrollieren",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "einfache Betriebsstörungen beseitigen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "nichtsicherheitskritische Reinigungs-, Pflege- und Wartungsarbeiten",
          },
        ],
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Fachpersonal/Einrichter",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Erläuterung:",
        bold: true,
      },
      {
        text: " Das Fachpersonal ist höher qualifiziert als das Bedienpersonal. Aufgrund ihrer Ausbildung, ihres Studiums und ihrer beruflichen Erfahrung ist es in der Lage, auch komplexere Aufgaben sicher auszuführen, ohne sich selbst oder andere zu gefährden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Folgende Aufgaben bleiben dem ausreichend qualifizierten und autorisierten Fachpersonal des Betreibers vorbehalten:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Einrichtearbeiten nach Produktwechsel an laufender Maschine",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "nicht sicherheitskritische Wartungsarbeiten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "wechseln nicht sicherheitskritischer, mechanischer Komponenten",
          },
        ],
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Wartungspersonal des Betreibers",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Erläuterung:",
        bold: true,
      },
      {
        text: " Wartungspersonal führt regelmäßige Wartungsarbeiten, Reparaturen und Inspektionen durch und ist in der Lage, technische Probleme zu diagnostizieren und zu beheben. Es verfügt über umfassende Kenntnisse der Maschine und ihrer Funktionsweise und kennt die erforderlichen Maßnahmen zur Sicherstellung eines sicheren Betriebs.",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "die (erst-)Inbetriebnahme und das Einrichten neuer Komponenten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Sicherheitskritische Wartungsarbeiten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Sicherheitskritische Instandhaltungs- und Reparaturarbeiten",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Restrisiken beim Betrieb",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Grundvoraussetzungen für einen sicheren Umgang mit der Anlage während des Betriebs sind die Befolgung und Beachtung der allgemeinen Arbeitssicherheitsvorschriften, des Arbeitsschutzes, der Betriebssicherheitsverordnung sowie der örtlichen und betriebsinternen Vorschriften.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Obwohl der Hersteller die Haftung für die Konstruktion der Maschine übernimmt, ist der Betreiber verpflichtet, eine Gefährdungsbeurteilung des Arbeitsplatzes beziehungsweise der Tätigkeiten an oder mit der Maschine durchzuführen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Hinweis: bitte nicht zutreffendes streichen oder weitere hinzufügen<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Gefahr durch unerwartetes Ingangsetzen!",
        bold: true,
      },
      {
        text: " Im Arbeitsbereich der Anlage können sich Anlagenteile unerwartet in Bewegung setzen. Betreten Sie den Arbeitsbereich nur, wenn die gesamte Anlage stillgesetzt wurde.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Gefahr, eingezogen zu werden!",
        bold: true,
      },
      {
        text: " An der Anlage gibt es bewegte Teile. Fassen Sie nicht in deren Nähe und benutzen die Anlage nur, wenn alle Schutzeinrichtungen geschlossen und funktionsfähig sind.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Benutzen Sie die Anlage nicht",
        bold: true,
      },
      {
        text: ", wenn Sicherheitseinrichtungen fehlen, beschädigt, überbrückt, manipuliert oder funktionsunfähig sind.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Stolpergefahr! Die Arbeitsplätze und Verbindungswege müssen frei zugänglich sein und dürfen nicht durch beispielsweise abgestellte Gegenstände versperrt sein.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Luftansaugöffnungen",
        bold: true,
      },
      {
        text: " in der Anlage dürfen nicht zugestellt werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Gefahren durch Anwenderfehler!",
        bold: true,
      },
      {
        text: " Die Anlage darf nur bedient werden, wenn der Bediener eine entsprechende Unterweisung erhalten hat.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Tragen Sie persönliche Schutzausrüstung! Tragen Sie während des Betriebs die ausgewiesene persönliche Schutzausrüstung: Fußschutz, Kopfschutz, Gehörschutz, Handschuhe.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Gefahr durch Schall! ",
        bold: true,
      },
      {
        text: "Die Maschine verursacht im Betrieb einen Schalldruckpegel von über 85 dB(A). Tragen Sie einen geeigneten Gehörschutz.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Quetschgefahr! ",
        bold: true,
      },
      {
        text: "Fassen Sie beim Anheben einer Last nicht an das Lastaufnahmemittel, die Anschlagmittel oder die Last.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Explosionsgefahr!",
        bold: true,
      },
      {
        text: " Die Anlage ist nicht für den Einsatz in explosionsgefährdeter Atmosphäre geeignet.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Sicherheitseinrichtungen",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Allgemeine Hinweise",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Sicherheit der Benutzer und des Betriebs-, Wartungs- und Servicepersonals ist nur dann gewährleistet, wenn alle Sicherheitseinrichtungen vollständig und funktionsfähig sind.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Anlage darf nicht genutzt werden, wenn Sicherheitseinrichtungen fehlen, beschädigt oder außer Funktion sind.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Trennende Schutzeinrichtungen ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Unautorisiertes Personal darf keine trennende Schutzeinrichtungen, Abdeckungen oder Gehäuseteile demontieren.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Der Betrieb der Anlage bei fehlenden oder beschädigten Schutzeinrichtungen ist verboten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Türkontaktschalter",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Es ist nicht gestattet, Sicherheitseinrichtungen wie Türkontaktschalter zu demontieren oder zu manipulieren.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Der Betrieb der Anlage bei fehlenden, beschädigten oder manipulierten Sicherheitseinrichtungen ist verboten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Not-Halt-Einrichtungen",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "info",
    children: [
      {
        type: "title",
        children: [
          {
            text: "INFORMATION/EMPFEHLUNG!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Die Bediener müssen in der Erstunterweisung mit der Funktion und den Positionen der Not-Halt-Einrichtungen vertraut gemacht werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "In folgenden Fällen wird Not-Halt ausgelöst: ",
        bold: true,
      },
      {
        bold: true,
        text: ">Hinweis: bitte auf Vollständigkeit und Richtigkeit prüfen<",
        highlight: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "nach Betätigen eines Not-Halt-Geräts,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "nach dem Öffnen eines Sicherheitsschalters,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "nach Berühren einer Kontaktleiste,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "nach Unterbrechen einer Lichtschranke/eines Lichtvorhangs.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Nach dem Betätigen der Not-Halt-Einrichtung befindet sich die Anlage in folgendem Zustand:",
        bold: true,
      },
      {
        bold: true,
        text: ">Hinweis: bitte auf Vollständigkeit und Richtigkeit prüfen<",
        highlight: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Alle bewegten Anlagenteile stehen still.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Alle bewegten Anlagenteile kommen möglichst schnell, aber ohne neue Gefährdungen zu erzeugen, zum Stehen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Alle elektrischen Spannungen an der Anlage sind abgeschaltet.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Die Störung wird durch optische Signalgeber angezeigt.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Die Störung muss vor dem Wiedereinschalten quittiert werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "warning",
    children: [
      {
        type: "title",
        children: [
          {
            text: "ACHTUNG",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Benutzen Sie die Not-Halt-Funktion nicht zum regulären Stillsetzen der Anlage! Wird ein ",
          },
          {
            text: "Not-Halt während des Betriebs",
            bold: true,
          },
          {
            text: " ausgelöst, können ",
          },
          {
            text: "Ausschussteile oder Sachschäden",
            bold: true,
          },
          {
            text: " an der Anlage entstehen!",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Sicherheitsmaßnahmen durch den Betreiber",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Verhalten bei Unfällen",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Falls noch nicht erfolgt, die Anlage sofort über eine Not-Halt-Einrichtung stillsetzen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Erste Hilfe für den Verletzen leisten, einen Arzt rufen und mitteilen, welche Verletzung vorliegt. Den Anweisungen des Notdienstes Folge leisten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Den Verunglückten niemals unbeaufsichtigt lassen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Alle allgemeingültigen sowie örtlichen Regelungen für das Verhalten und Vorgehen in Notfällen sind zu beachten.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h3",
    children: [
      {
        text: "Verhalten bei Feuer/Brand",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Im Brandfall, der auf Elektrizität zurückzuführen ist, muss die Anlage von der elektrischen Verbindung getrennt werden. Dies ermöglicht eine wirkungsvolle Bekämpfung des Brandes. ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "WARNUNG!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Bei Bränden, die auf Elektrizität zurückzuführen sind, dürfen keine Wasser- oder Schaumfeuerlöscher eingesetzt werden. Für Elektrobrände sind geeignete Pulverfeuerlöscher zu nutzen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Beschreibung der Maschine",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Baugruppenübersicht",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Anlage besteht im Wesentlichen aus den folgenden Komponenten:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "image",
    url: "data:image/png;base64,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",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Pos.",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Bezeichnung",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Funktionsbeschreibung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Hinweis für den User:",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Beschreiben Sie, aus welchen Hauptkomponenten die Maschine/Anlage besteht, und beziehen Sie sich dabei auf die Abbildung sowie die Tabelle mit den Positionsnummern und Bezeichnungen.",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Erläutern Sie die Funktionsweise sowie den Input und Output der Maschine/Anlage. Vermeiden Sie dabei zu detaillierte Beschreibungen von Bedienung, Betriebsarten und Wartung, da diese an anderer Stelle der Betriebsanleitung behandelt werden. Dieses Kapitel dient dazu, dem Leser einen Überblick über die grundlegende Funktion der Maschine/Anlage zu geben.<",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Technische Daten",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Parameter",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Wert",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Produktbezeichnung, Typ",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "projectdata.product_name",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: " ",
              },
              {
                type: "project-data",
                key: "projectdata.type",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Produkt-/Serien-Nr.",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "projectdata.type",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Elektroanschluss",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.electrical_voltage",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Leistungsaufnahme",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.power_consumption",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Netzabsicherung",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.grid_protection",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Pneumatischer Anschluss",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.pneumatic_max",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Hydraulischer Anschluss",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.hydraulic_max",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Temperatur",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.temperature",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Luftfeuchtigkeit",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.humidity",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Arbeitsumgebung",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.usage_environment",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Max. Tragfähigkeit",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.load_limit",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Abmessungen (BxHxL)",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.dimensions",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Schalldruckpegel LpA",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.noise_emission",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Eigengewicht",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
              {
                type: "project-data",
                key: "boundary.weight",
                children: [
                  {
                    text: "",
                  },
                ],
              },
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Typenschild",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "An dem Förderer befindet sich gut sichtbar ein Typenschild mit allen erforderlichen Daten.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Kennzeichnung muss sich jederzeit gut lesbar an der Maschine befinden!",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Hinweis: Typenschild als Bild einfügen<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Transport",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "VORSICHT!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Der innerbetriebliche Transport (inkl. Transport von Lieferort zur geplanten Einsatzstelle) darf grundsätzlich nur durch unterwiesenes Personal des Betreibers durchgeführt werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Folgende Dinge sind bei Anlieferung und Transport zu beachten:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Sind an der Baugruppe Anschlagpunkte, Ringschrauben zum Anschlagen, Taschen für Staplergabeln oder ähnliches vorhanden, sind diese beim Transport zwingend zu nutzen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Wird für den Transport ein Hebezeug, Flurförderzeug oder ein anderes Transportmittel benötigt, darf dieses nur durch Personen bedient werden, welche zu dessen Bedienung autorisiert und in dieser unterwiesen wurden. Beim Transport auf einer Ladefläche muss die Ladung vorschriftsmäßig gesichert werden.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Beim Transport auf einer Ladefläche sind die Vorder- und Hinterräder mit Keilen gegen ein Verrutschen zu sichern / muss die Ladung vorschriftsmäßig gesichert werden",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Alle losen Teile müssen sorgfältig an den Baugruppen befestigt oder separat transportiert werden.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Bei Transport und Anlieferung sollten Sicherheitsschuhe und ggf. Schutzhelme getragen werden, um Stoß- und Quetschverletzungen zu vermeiden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Überprüfen Sie die Lieferung auf Beschädigungen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Sollten Sie Beschädigungen entdecken, dokumentieren Sie diese und wenden Sie sich an den Hersteller.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: " ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Aufstellung/Montage",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "warning",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Vorsicht!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Aufstellung und Montage dürfen grundsätzlich nur durch autorisiertes und unterwiesenes Servicepersonal durchgeführt werden.",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Aufstellung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Folgende Dinge sind bei der Aufstellung der Anlage zu beachten:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Die Anlage ist nur für den Betrieb in ",
          },
          {
            type: "project-data",
            key: "boundary.location",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            text: " geeignet.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Die Baugruppen sind gemäß der Übersichtszeichnung zu positionieren.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Achten Sie vor dem Transport darauf, dass am geplanten Aufstellungsort alle benötigten Anschlüsse (Druckluft, Wasser etc.) und/oder Absaugungen (falls erforderlich) vorhanden sind.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Beim Aufstellen der Anlage ist darauf zu achten, dass die Zuwegungen frei zugänglich sind. Umlaufend ist mindestens ",
          },
          {
            type: "project-data",
            key: "boundary.spatial_boundary",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            text: " für die Bedienung, Reparatur und Wartungsarbeiten vorzusehen.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Es ist ferner darauf zu achten, dass die umliegenden Laufwege frei von Stolperfallen wie Kabeln oder ähnlichem sind.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Vor der Aufstellung der Baugruppen gilt es zu überprüfen, ob der Untergrund die erforderliche Tragfähigkeit (siehe Auftragsbestätigung) aufweist. Ist dies nicht der Fall, sind entsprechende Fundamente vorzubereiten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Für den An- und Abtransport der Komponenten ist sicherzustellen, dass jeweils genügend Platz zur Verfügung steht.",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Montage",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Um einen betriebsbereiten Zustand zu erlangen sind folgende Montagearbeiten erforderlich:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Inbetriebnahme",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Warnung!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Die (Erst-)Inbetriebnahme darf ausschließlich durch ausreichend qualifiziertes und autorisiertes Servicepersonal des Betreibers erfolgen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Vor der (Erst-)Inbetriebnahme müssen alle Montagearbeiten (siehe Kapitel 4) abgeschlossen sein.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Achten Sie darauf, dass folgende Tätigkeiten durchgeführt und abgeschlossen sind:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Montage der mechanischen Elemente,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Montage und Anschluss der Elektronik.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Montage und Anschluss der Hydraulik/Pneumatik,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Montage und Anschluss der Absaugung und",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Montage und Überprüfung der sicherheitsrelevanten Elemente und Einrichtungen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Probelauf",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Nach der Aufstellung und Montage muss ein Probelauf durch das Servicepersonal durchgeführt werden. Der Probelauf ist ein Test der Anlage im Arbeitsprozess ohne Belastung.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Vorgehensweise:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "alle Hilfsmittel und Werkzeuge von der Anlage entfernen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Energieversorgung einschalten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Folgende Punkte überprüfen:",
          },
        ],
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Funktion aller Not-Halt-Einrichtungen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Laufrichtung der Antriebe",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Funktion der Sensoren ",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "auf Geräusche achten, die von der „Norm“ abweichen",
          },
        ],
      },
    ],
  },
  {
    type: "message-box",
    boxType: "info",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Empfehlung:",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Die erfolgreiche Durchführung des Probelaufs durch das Fachpersonal sollte schriftlich dokumentiert werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "\t ",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Übergabe in den Normalbetrieb",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Nach Freigabe der Maschine durch das Servicepersonal darf die Maschine dem regulären Betriebspersonal übergeben werden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Das reguläre Betriebspersonal ist vor dem Beginn seiner Arbeit in den Umgang mit der Anlage einzuweisen.",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "info",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Empfehlung:",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Die Durchführung von Unterweisungen sollte schriftlich protokolliert werden. Unterweisungen müssen vor Aufnahme der Tätigkeit erfolgen und regelmäßig wiederholt werden!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Unterweisungsprotokolle sind ein wichtiger Bestandteil der Dokumentation und sind im Bedarfsfall den entsprechenden Aufsichtsbehörden vorzulegen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "\t ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: " ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Betrieb der Anlage",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Einschalten",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Beschreiben Sie hier die notwendigen Handlungsschritte, um die Maschine einzuschalten und in einen betriebsbereiten Zustand zu versetzen.<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Normalbetrieb",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Beschreiben Sie hier die notwendigen Handlungsschritte, um die Maschine bestimmungsgemäß zu verwenden.<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Ausschalten",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: ">Beschreiben Sie hier die notwendigen Handlungsschritte, um die Maschine auszuschalten.<",
        highlight: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Müssen weitere Betriebsarten beschrieben werden? Diese können Sie an dieser Stelle als Freitext hinzufügen. Typische weitere Betriebsarten sind beispielsweise:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "•\tAutomatikbetrieb",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "•\tManueller Betrieb (Handbetrieb)",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "•\tEinrichtbetrieb (Setup-Modus)",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "•\tNotbetrieb<",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Wartung",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Sicherheit bei Inspektion und Wartung",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "danger",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Warnung!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Wartungsarbeiten dürfen grundsätzlich nur durch autorisiertes und ausreichend qualifiziertes Servicepersonal durchgeführt werden.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Arbeiten Sie sorgfältig. Gibt es ergänzende Dokumentationen, Anleitungen, Datenblätter oder Wartungsinformationen zu Einbaukomponenten, Ersatzteilen, Betriebsmitteln o. ä. beachten Sie unbedingt die dortigen Angaben und Warnhinweise.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Führen Sie die beschriebenen Handlungen nur dann aus, wenn Ihnen der Handlungsablauf und die dabei auftretenden Risiken verständlich sind.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Mit Fragen zur Instandsetzung wenden Sie sich bitte an den Service des Herstellers.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Vor Beginn der Wartungsarbeiten",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Bei allen Arbeiten an der Anlage einschließlich Steuereinheit:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Bringen Sie deutlich sichtbar gut lesbare Schilder an, die hinzukommende Personen über laufende Instandhaltungsarbeiten informieren.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Schalten Sie den Hauptschalter aus.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Sichern Sie den Hauptschalter gegen Wiedereinschalten.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Schalten Sie die Anlage drucklos.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Lassen Sie, wenn nötig, die Anlage vor Beginn der Arbeiten abkühlen (Restwärme an Motoren etc.).",
          },
        ],
      },
    ],
  },
  {
    type: "message-box",
    boxType: "warning",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Vorsicht!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Bevor Sie mit Wartungsarbeiten beginnen, prüfen Sie:",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "•\tden stromlosen Zustand der Anlage,",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "•\tob die Anlage drucklos ist.",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Wartungsarbeiten",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Der folgende Wartungsplan listet alle nötigen Wartungen auf. Die angegebenen Intervalle sind dabei Mindestanforderungen, das heißt, je nach Häufigkeit der Verwendung, bei stark verschmutzter oder aggressiver Arbeitsumgebung etc. sind die Wartungsarbeiten häufiger durchzuführen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: " ",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Wartung",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Wartungsintervall",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "einfache Sichtkontrolle der Anlage",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "vor jedem Einsatz",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Reinigung aller äußeren, erreichbaren Oberflächen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "wöchentlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "auf offensichtlich erkennbare Beschädigungen oder Ermüdungserscheinungen prüfen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "halbjährlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "alle Schraubenverbindungen prüfen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "halbjährlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "elektrische Einrichtungen durch eine Elektrofachkraft prüfen lassen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "jährlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "alle Pneumatik-Schlauchverbindungen auf Verschleiß prüfen und ggf. austauschen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "halbjährlich*",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "alle Hydraulik-Schlauchverbindungen auf Verschleiß prüfen und ggf. austauschen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "halbjährlich*",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Funktion und Wirksamkeit aller Sicherheitseinrichtungen prüfen",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "jährlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Antriebe kontrollieren und schmieren",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "jährlich",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "Kontrolle der Typenschilder, Piktogramme und Warnhinweise auf Vollständigkeit und Lesbarkeit",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "jährlich",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "*: Spätestens nach Erreichen der maximalen Lebensdauer oder Lagerzeit müssen Schlauchverbindungen ausgetauscht werden, auch wenn diese keinen erkennbaren Verschleiß aufweisen.",
        italic: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Nach Abschluss der Wartungsarbeiten",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Stellen Sie vor dem Wiedereinschalten sicher, dass:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "alle Instandhaltungs- und Hilfsmittel (zum Beispiel Werkzeug, Putzzeug, Mess- und Prüfgeräte) aus der Anlage entfernt wurden,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "alle trennenden Schutzeinrichtungen wieder korrekt montiert wurden,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "alle Sicherheitseinrichtungen wieder funktionsfähig sind,",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "sich keine Personen mehr in Gefährdungsbereichen aufhalten.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Störungsbeseitigung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Störung/Symptom",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Mögliche Ursachen",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Abhilfe",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Wenn die oben genannten Schritte die Probleme nicht lösen können, wenden Sie sich bitte an unseren Kundendienst:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Hersteller:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.company",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        bold: true,
        text: "Anschrift:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.street_address",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.post_code",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " ",
      },
      {
        type: "project-data",
        key: "manufacturer.city",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.country",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Telefon:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.phone",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "E-Mail:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.email_adress",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Website:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.website",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Halten Sie dabei Bezeichnung, Typ, Baujahr, Seriennummer etc. der Anlage bereit.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Diese Informationen finden Sie auch auf dem Typenschild.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Entsorgung",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Gesetzliche Grundlagen",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Entsorgung hat gemäß den nationalen und örtlichen Bestimmungen zu erfolgen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Beachten Sie alle pflichten zur Abfallvermeidung und Wiederverwertung oder Beseitigung von Rohstoffen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Recycling",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Achten Sie darauf, Rohstoffe wenn möglich wiederzuverwerten, beispielsweise durch:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "die Überführung elektrischer Bauteile in den Elektroschrott",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "die sachgerechte Entsorgung von Batterien etc.",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "das sortenreine Recyceln metallischer Werkstoffe",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "und die sachgerechte Entsorgung von Kunststoffteilen.",
          },
        ],
      },
    ],
  },
  {
    type: "h2",
    children: [
      {
        text: "Vermeidung von Umweltschäden",
      },
    ],
  },
  {
    type: "message-box",
    boxType: "warning",
    children: [
      {
        type: "title",
        children: [
          {
            text: "Achtung!",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Bei der Demontage können gegebenenfalls Stoffe freigesetzt werden, welche die Umwelt schädigen oder belasten.",
          },
        ],
      },
      {
        type: "content",
        children: [
          {
            text: "Vermeiden Sie Umweltschäden durch sachgerechte Entsorgung! Lassen Sie die Entsorgung, wenn nötig, durch ein zugelassenes Fachunternehmen durchführen.",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Folgende Erzeugnisse können Schäden an der Umwelt hervorrufen:",
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Schmiermittel, -fette, -öle",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Hydraulikflüssigkeiten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Batterien",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "bestimmte Elektronikbauteile",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "aggressive Reinigungsmittel",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Ersatzteile",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Setzen Sie für die Instandhaltung oder Reparatur der Maschine ausschließlich folgende Original-Ersatzteile ein. Die Verwendung nicht hier gelisteter Bauteile kann zur zu Gefahren führen. ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Pos.",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Bezeichnung",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Teilnummer",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "ODER ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Für Ersatzteile wenden Sie sich bitte an unseren Ersatzteilservice:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Hersteller:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.company",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        bold: true,
        text: "Anschrift:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.street_address",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.post_code",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: " ",
      },
      {
        type: "project-data",
        key: "manufacturer.city",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.country",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Telefon:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.phone",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "E-Mail:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.email_adress",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Website:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "manufacturer.website",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Halten Sie dabei Bezeichnung, Typ, Baujahr, Seriennummer etc. der Anlage bereit.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Diese Informationen finden Sie auch auf dem Typenschild.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Technische Übersichtszeichnung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Konformitätserklärung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Abkürzungsverzeichnis",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Folgende Abkürzungen finden sich im Text dieser Anleitung:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Abkürzung",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Bedeutung",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Glossar",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "autorisiert ",
        bold: true,
      },
      {
        text: "bedeutet, dass die Person vom Betreiber oder Hersteller dazu angewiesen wurde, die genannten Tätigkeiten durchzuführen. Der Betreiber/Hersteller muss sicherstellen, dass die Person ausreichend qualifiziert ist, um die angewiesene Arbeit sicher durchzuführen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "bestellt/beauftragt",
        bold: true,
      },
      {
        text: " bedeutet, dass eine Person schriftlich durch den Betreiber oder Hersteller dazu autorisiert wurde, eine Tätigkeit durchzuführen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "geschult/unterwiesen",
        bold: true,
      },
      {
        text: " bedeutet, dass die Person in einer Schulung in der Durchführung der genannten Tätigkeiten unterwiesen wurde. Diese Unterweisung sollte dokumentiert werden. Eine geschulte/unterwiesene Person ist über bestehende Restrisiken informiert.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "qualifiziert",
        bold: true,
      },
      {
        text: " bedeutet, dass die Person aufgrund ihrer Ausbildung, ihres Studiums, langjähriger Berufserfahrung o. ä. dazu in der Lage ist, die angewiesene Tätigkeit durchzuführen, ohne sich oder andere dabei zu gefährden. Die Person ist mit bestehenden Restrisiken vertraut und aufgrund ihrer Qualifikation in der Lage, diese einzuschätzen und wenn möglich zu verhindern.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "sicherheitskritisch",
        bold: true,
      },
      {
        text: " bedeutet, dass die fehlerfreie Arbeitsweise der genannten Komponenten unerlässlich ist, um den sicheren Betrieb, die Wartung etc. der Anlage zu gewährleisten. Sind sicherheitskritische Komponenten defekt oder werden von unzureichend qualifiziertem beziehungsweise geschultem Personal bedient/gewartet, kann es zu schweren Verletzungen bis hin zum Tod von Personen kommen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Bediener",
        bold: true,
      },
      {
        text: " sind geschulte Personen, welche im Normalbetrieb die Anlage bedienen. Je nach Anlage dürfen Bediener außerdem einfache, nicht sicherheitskritische Arbeiten im Bereich Fehlerbeseitigung, Reparatur, Inspektion, Wartung durchführen. Welche dieser Tätigkeiten der Bediener selbst durchführen und welche ausschließlich das Servicepersonal durchführen darf, wird in der Bedienungsanleitung im Kapitel zur Wartung definiert.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Elektrofachkraft",
        bold: true,
      },
      {
        text: " ist eine Fachkraft, die insbesondere im Umgang mit elektrischen Anlagen vertraut ist. Sie kennt und versteht die speziellen Risiken, die mit der Arbeit an elektrischen Installationen einhergehen, und kann ihre Arbeiten durchführen, ohne sich oder andere zu gefährden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Fachkraft ",
        bold: true,
      },
      {
        text: "ist eine Person, die ausreichend qualifiziert ist, um die angewiesene Tätigkeit durchzuführen, ohne sich oder andere dabei zu gefährden. Die Person ist mit bestehenden Restrisiken vertraut und aufgrund ihrer Qualifikation in der Lage, diese einzuschätzen und wenn möglich zu verhindern. ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Geschultes Personal",
        bold: true,
      },
      {
        text: " beinhaltet alle vom Betreiber angestellten Mitarbeiter, die im Umgang mit der betreffenden Anlage, der Arbeitsumgebung und den Sicherheitseinrichtungen unterwiesen wurden. Diese Personen sind über bestehende Restrisiken informiert.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Inbetriebnahmepersonal",
        bold: true,
      },
      {
        text: " ist Servicepersonal, welches speziell für die Inbetriebnahme einer Anlage autorisiert ist. Es kann entweder zum Betreiber oder zum Hersteller gehören.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Kundendienstpersonal",
        bold: true,
      },
      {
        text: " ist Servicepersonal des Herstellers. Diese Mitarbeiter sind vom Hersteller autorisiert, Arbeiten an sicherheitskritischen Komponenten durchzuführen. Der Hersteller gewährleistet, dass seine Mitarbeiter ausreichend geschult und qualifiziert sind, die geforderten Tätigkeiten durchzuführen, ohne sich oder andere zu gefährden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Personal",
        bold: true,
      },
      {
        text: " beinhaltet alle vom Betreiber angestellten Mitarbeiter und damit auch Personen aus anderen Betriebsbereichen, die mit der betreffenden Anlage, der Arbeitsumgebung und den Sicherheitseinrichtungen nicht vertraut sind. Diese Personen sind daher über bestehende Restrisiken möglicherweise nicht informiert und können diese auch nicht vermeiden. Solche Personen sind von Gefährdungsquellen fernzuhalten und durch Warn- oder Verbotsschilder zu informieren. ",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Servicepersonal",
        bold: true,
      },
      {
        text: " beinhaltet alle geschulten und qualifizierten Mitarbeiter des Betreibers oder des Herstellers, die autorisiert sind, die Inbetriebnahme, Wartung, Instandhaltung, Inspektion etc. an sicherheitskritischen Komponenten durchzuführen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Systemintegrator",
        bold: true,
      },
      {
        text: " ist eine Fachkraft des Betreibers, die dazu qualifiziert und vom Betreiber dazu autorisiert ist, die Verkettung einer Maschine/Anlage mit weiteren Maschinen/Anlagen durchzuführen. Der Systemintegrator ist dafür verantwortlich, die Konformität dieser „Gesamtheit von Maschinen“ zu bewerten und ggf. zusätzliche Sicherheitsmaßnahmen zu definieren.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Vertragspartner",
        bold: true,
      },
      {
        text: " ist Servicepersonal einer Drittfirma, welche einen Vertrag mit dem Hersteller eingegangen ist. Diese Vertragspartner sind vom Hersteller autorisiert, Arbeiten an sicherheitskritischen Komponenten durchzuführen. Der Vertragspartner gewährleistet, dass seine Mitarbeiter ausreichend geschult und qualifiziert sind, die geforderten Tätigkeiten durchzuführen, ohne sich oder andere zu gefährden.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Wartungspersonal",
        bold: true,
      },
      {
        text: " ist Servicepersonal, welches speziell für die Wartung einer Anlage autorisiert ist. Es kann entweder zum Betreiber oder zum Hersteller gehören.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Unterweisungs- und Schulungshilfe",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Als Unternehmer/Betreiber sind Sie verpflichtet, das Bedienpersonal über bestehende Rechts- und Unfallverhütungsvorschriften sowie über vorhandene Sicherheitseinrichtungen der Anlage zu informieren beziehungsweise zu unterweisen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Diese Verpflichtung erstreckt sich auch auf solche Sicherheitseinrichtungen, die im Zusammenhang mit der Nutzung der Anlage genutzt werden, beziehungsweise installiert sind. Dabei sind die verschiedenen fachlichen Qualifikationen der Mitarbeiter zu berücksichtigen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Das Bedienpersonal muss die Unterweisung verstanden haben und es muss sichergestellt sein, dass die Unterweisung beachtet wird.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Nur so erreichen Sie ein sicherheits- und gefahrenbewusstes Arbeiten Ihres Personals. Die Beachtung der Unterweisung sollte regelmäßig kontrolliert werden. Als Unternehmer/Betreiber sollten Sie sich daher die Teilnahme an einer Unterweisung von jedem Mitarbeiter schriftlich bestätigen lassen.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Auf den folgenden Seiten finden Sie Beispiele für Schulungsthemen sowie für die Teilnahmebestätigung an der Schulung/Unterweisung ein Formular als Kopiervorlage.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Schulungsthemen",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "1.\tZur allgemeinen Sicherheit",
        bold: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Unfallverhütungsvorschriften",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Allgemeine Rechtsvorschriften",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Allgemeine Sicherheitshinweise",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Maßnahmen im Notfall",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Sicherheitshinweise für den Betrieb der Anlage",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Sicherheitseinrichtungen im Umfeld der Anlage",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Bedeutung von Symbolen und Schildern",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "_____________________________________________",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "_____________________________________________",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "2.\t Zum Umgang mit der Anlage",
        bold: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Umgang mit den Bedienelementen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Richtiges Anlegen der Anlage",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Ergonomisch richtiges Heben und Tragen von Lasten",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Erläuterung der Bedienungsanleitung für das Bedienpersonal",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Besondere Erfahrungen des Betreibers im Umgang mit der Anlage",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Beseitigung von Störungen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "______________________________________________",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "______________________________________________",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "3.\tZu Instandhaltungs- und Wartungsvorschriften",
        bold: true,
      },
    ],
  },
  {
    type: "ul",
    children: [
      {
        type: "li",
        children: [
          {
            text: "Vorschriftsmäßiger Umgang mit Reinigungsmitteln und Schmierstoffen",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "Besondere Erfahrung des Betreibers in den Bereichen Wartung, Instandhaltung, Reinigung und Pflege der Anlage",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "______________________________________________",
          },
        ],
      },
      {
        type: "li",
        children: [
          {
            text: "______________________________________________",
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "h1",
    children: [
      {
        text: "Bestätigung der Unterweisung",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Die Unterweisung behandelt das folgende Produkt:",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Handelsname:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "projectdata.product_name",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Typ:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "projectdata.type",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Zeitpunkt des Inverkehrbringens:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "projectdata.launch_date",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Maschinennummer(n):",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "projectdata.serial_number",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Produktgattung/-kategorie:",
        bold: true,
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
      {
        type: "project-data",
        key: "projectdata.category",
        children: [
          {
            text: "",
          },
        ],
      },
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Thema der Unterweisung:                _________________________________________",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Dauer der Unterweisung:                 _________________________________________",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Schulungsleiter:                                _________________________________________",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Unterschrift des Schulungsleiters:    _________________________________________",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Mit dem Unterzeichnen dieser Liste bestätigen Sie, dass Sie die Inhalte dieser Unterweisung verstanden haben.",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
  {
    type: "table",
    children: [
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Nr.:",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Name, Vorname:",
              },
            ],
          },
          {
            type: "table-cell",
            isHeader: true,
            children: [
              {
                text: "Unterschrift:",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
      {
        type: "table-row",
        children: [
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
          {
            type: "table-cell",
            children: [
              {
                text: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
];
